<template>
  <div class="deck-connect-passage-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <span class="font14 mr-10">当前甲板</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{deckName}}</el-breadcrumb-item>
        </el-breadcrumb>
        <!--<div class="elalert">-->
        <!--<el-alert :title="当前甲板共6条过道" type="success"></el-alert>-->
        <!--</div>-->
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-button-group class="mr-10">
        <el-button @click="clickAdd" size="mini" type="primary" icon="el-icon-plus">新增连接</el-button>
      </el-button-group>
      <div class="list">
        <div class="item" v-for="(item,index) in list" :key="index">
          <div class="div">
            <div><span>过道1：</span>{{item.passage1_name}}</div>
            <div><span>过道1连接点：</span>{{item.passage1_point == 'left_up' ? '左/上' : '右/下'}}</div>
            <div><span>过道2：</span>{{item.passage2_name}}</div>
            <div><span>过道2连接点：</span>{{item.passage2_point == 'left_up' ? '左/上' : '右/下'}}</div>
            <!--<div class="mt-5"><span>设置连接线：</span>-->
            <!--<el-button type="primary" size="mini" @click="setLine">设置</el-button>-->
            <!--</div>-->
            <div class="btn">
              <el-button-group class="mr-10">
                <el-button type="primary" size="mini" @click="clickEdit">修改</el-button>
                <el-button type="primary" size="mini" @click="del">删除</el-button>
              </el-button-group>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">过道1</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择">
            <el-option
                v-for="item in [{value:'过道1',label:'过道1'},{value:'过道2',label:'过道2'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">过道1连接点</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择">
            <el-option
                v-for="item in [{value:'上/左',label:'上/左'},{value:'下/右',label:'下/右'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">过道2</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择">
            <el-option
                v-for="item in [{value:'过道1',label:'过道1'},{value:'过道2',label:'过道2'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">过道2连接点</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择">
            <el-option
                v-for="item in [{value:'上/左',label:'上/左'},{value:'下/右',label:'下/右'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <!--<div class="o-hidden">-->
        <!--<span class="span">连接方式</span>-->
        <!--<el-select style="width:100%" size="mini" disabled value="直接连线" placeholder="请选择">-->
        <!--<el-option-->
        <!--v-for="item in [{value:'直接连线',label:'直接连线'},{value:'加连接点',label:'加连接点'}]"-->
        <!--:key="item.value" :label="item.label" :value="item.value"></el-option>-->
        <!--</el-select>-->
        <!--</div>-->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  import {mock} from '../../common/js/mock.js';
  export default {
    data() {
      return {
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {name: ""},
        addDialogShow: false,
        id: 0,
        deckName: ''
      };
    },

    computed: {},

    created() {
      this.id = this.$route.query.id;
      console.log(this.id);
      this.getData();
    },

    watch: {
      $route(to, from){
        this.id = this.$route.query.id;
        console.log(this.id);
        this.getData();
      },
      //id(){
      //  console.log(this.id);
      //},
    },

    methods: {
      setLine(){
        this.$router.push({path: "/monitoring/realtime"});
      },

      del(){
        this.$confirm("确定要删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          alert('调用删除接口');
        });
      },

      clickAdd(){
        this.addDialogShow = true;
      },

      clickEdit(){
        this.addDialogShow = true;
      },

      submit(){
      },

      getData(flag) {
        console.log(mock.deck_connect_passage);
        for (let i = 0; i < mock.deck_connect_passage.length; i++) {
          if (this.id == mock.deck_connect_passage[i].deck_id) {
            this.list = mock.deck_connect_passage[i].connect;
            this.deckName = mock.deck_connect_passage[i].deck_name;
            break;
          }
        }
        console.log(this.list);
      },
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  .deck-connect-passage-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px 15px 5px 15px;
    flex-direction: column;
    .btn-box {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      .elalert {
        position: absolute;
        right: -7px;
        top: -10px;
        width: 200px;
      }
    }
    .table {
      min-height: 400px;
      .list {
        margin-top: 15px;
        .item {
          float: left;
          width: 50%;
          margin-bottom: 10px;
          position: relative;
          &:nth-child(2n+1) {
            padding-right: 5px;
          }
          &:nth-child(2n) {
            padding-left: 5px;
          }
          .div {
            width: 100%;
            height: auto;
            padding: 15px 0 20px 20px;
            background: #e6e8ef;
            line-height: 30px;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            justify-content: center;
            .btn {
              position: absolute;
              right: 15px;
              top: 15px;
            }
            & > div > span {
              display: inline-block;
              width: 120px;
              color: #444;
            }
          }
        }
      }
    }
    .add-box {
      .span {
        width: 120px;
      }
    }
  }
</style>
